import React, { useEffect } from "react";
import "./styles.productServices.css";
import image1 from "../../assets/products/image 352.svg";
import image2 from "../../assets/products/image 374.svg";
import image3 from "../../assets/products/image 420.svg";
import image4 from "../../assets/products/image 468.svg";
import image5 from "../../assets/products/image 360.svg";
import image6 from "../../assets/products/image 337.svg";
import arrow from "../../assets/products/arrow.svg";
import { useNavigate } from "react-router-dom";
export default function ProdServices() {
  const navigate = useNavigate();
  const handleViewProduct = (index, e) => {
    navigate(`/gallery/project${index + 1}`);
  };
  useEffect(() => {
    const scrollOneScreenDown = () => {
      const screenWidth = window.innerWidth;
      const isLargeScreen = screenWidth > 768;
      if (isLargeScreen) {
        const screenHeight = window.innerHeight * 0.9;
        const scrollPosition = screenHeight;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    };

    scrollOneScreenDown();
  }, []);
  const imageList = [
    {
      name: "image1",
      src: image1,
    },
    {
      name: "image2",
      src: image2,
    },
    {
      name: "image3",
      src: image3,
    },
    {
      name: "image4",
      src: image4,
    },
    {
      name: "image5",
      src: image5,
    },
    {
      name: "image6",
      src: image6,
    },
  ];

  return (
    <div className="product-container">
      <h1 className="product-title">
        WE SHAPE THE
        <br />
        PERFECT PRODUCTS
      </h1>
      <div>
        <div className="image-container">
          {imageList.map((data, index) => {
            return (
              <div className="last-container" key={index}>
                <img
                  src={data.src}
                  alt="metal"
                  className="image image-opacity"
                />
                <div
                  onClick={(e) => handleViewProduct(index, e)}
                  className="default-absolute"
                >
                  VIEW ALL <br />
                  PRODUCTS
                  <img src={arrow} alt="..." className="arrow-image" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
